import React from "react";
import styled from "styled-components";
import { TableCell, TableFooter, TableRow } from "./StyledTable";
import Dropdown from "./Dropdown";
import { ITEMS_PER_PAGE_OPTIONS } from "../../constants/OptionsConstants";

const TablePagination = ({
  page,
  totalPages = 1,
  onPrevious,
  onNext,
  leftColSpan = 1,
  rightColSpan = 1,
  centerColSpan,
  itemsPerPage,
  onItemsPerPageChange,
  itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS,
}) => {
  const showRowsPerPage = itemsPerPage !== undefined && !!onItemsPerPageChange;

  if (showRowsPerPage) {
    return (
      <TableFooter>
        <TableRow>
          <TableCell colSpan={leftColSpan} style={{ textAlign: "left" }}>
            <RowsPerPageGroup>
              <PageText>Rows per page</PageText>
              <div style={{ minWidth: 64 }}>
                <Dropdown
                  value={String(itemsPerPage)}
                  onValueChange={(v) => onItemsPerPageChange(Number(v))}
                  className="px-2 py-1 text-sm"
                  options={itemsPerPageOptions.map((v) => ({ value: String(v), label: String(v) }))}
                />
              </div>
            </RowsPerPageGroup>
          </TableCell>
          <TableCell colSpan={centerColSpan ?? rightColSpan} style={{ textAlign: "center" }}>
            <PageText>Page {page} of {totalPages}</PageText>
          </TableCell>
          <TableCell colSpan={rightColSpan} style={{ textAlign: "right" }}>
            <ButtonGroup style={{ justifyContent: "flex-end" }}>
              <NavButton disabled={page <= 1} onClick={onPrevious}>
                Previous
              </NavButton>
              <NavButton disabled={page >= totalPages} onClick={onNext}>
                Next
              </NavButton>
            </ButtonGroup>
          </TableCell>
        </TableRow>
      </TableFooter>
    );
  }

  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={leftColSpan}>
          <ButtonGroup>
            <NavButton disabled={page <= 1} onClick={onPrevious}>
              Previous
            </NavButton>
            <NavButton disabled={page >= totalPages} onClick={onNext}>
              Next
            </NavButton>
          </ButtonGroup>
        </TableCell>
        <TableCell colSpan={rightColSpan} style={{ textAlign: "right" }}>
          <PageText>Page {page} of {totalPages}</PageText>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default TablePagination;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const NavButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #e9eaeb;
  background: white;
  color: #344054;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PageText = styled.span`
  color: #667085;
  font-size: 14px;
`;

const RowsPerPageGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
